
export default {
  name: 'NotificationCard',
  props: {
    isNotificationOpen: {
      type: Boolean,
      default: false,
    },
    notifications: {
      type: [Object, Array],
      default: () => {},
    },
  },
}
